import React from 'react'
import { Link } from 'react-router-dom'
import SocialMedia from './SocialMedia'
const moment = require('moment')

function Footer({auth})
{
    return (
    <React.Fragment>
        <hr />
        {auth != "student" ? 
            <SocialMedia auth={auth} />
        : ""}

        <p>© {moment().format("YYYY")} Diarmuid, Inc.</p>
        
        <p><Link to="/legal/terms-of-use">Terms of Use</Link> - <Link to="/legal/privacy-policy">Privacy Policy</Link></p>
    </React.Fragment>)
}

export default Footer
